module.exports = __webpack_public_path__ + "static/media/zone2-roof.b28a8f38.png";